export default "__VITE_PUBLIC_ASSET__73990584__"